export default {
  $formatFileSizeUnits: (bytes) => {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + ' GB'
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + ' MB'
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + ' KB'
    } else if (bytes > 1) {
      bytes = bytes + ' bytes'
    } else if (bytes == 1) {
      bytes = bytes + ' byte'
    } else {
      bytes = '0 byte'
    }
    return bytes
  },
  $formatFileSizeUploadUnits: ({ total, loaded }) => {
    let result
    const toFixed = 1
    const separator = '/'
    if (total >= 1073741824) {
      result =
        (loaded !== total ? (loaded / 1073741824).toFixed(toFixed) + separator : '') +
        (total / 1073741824).toFixed(toFixed) +
        ' GB'
    } else if (total >= 1048576) {
      result =
        (loaded !== total ? (loaded / 1048576).toFixed(toFixed) + separator : '') +
        (total / 1048576).toFixed(toFixed) +
        ' MB'
    } else if (total < 1048576) {
      result =
        (loaded !== total ? (loaded / 1024).toFixed(toFixed) + separator : '') +
        (total / 1024).toFixed(toFixed) +
        ' KB'
    }
    return result
  },
  $getFileUrl: (file) => {
    return URL.createObjectURL(file)
  },
}
